import script from "./OrderInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./OrderInvoice.vue?vue&type=style&index=0&id=26c80b96&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c80b96"]])

export default __exports__